import {getTaskStatusFilter} from '../../../taskManagement/common/selectors'
import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'

export const setStatusFilter = createAction(ActionTypes.STATUS_FILTER_SET)

export const resetFilter = () => (dispatch, getState) => {
    const filterFromSettings = getTaskStatusFilter(getState())
    dispatch(setStatusFilter(filterFromSettings))
}




// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/actions.js